import React from 'react';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './redux/store';
import Index from './components/Common/Index/Index';
import DynamicMain from './components/Main/DynamicMain';
import DynamicPortfolioMain from './components/Main/DynamicPortfolioMain';
import Designer from './components/Designer/Designer';
import PageList from './components/Page/PageList';

import './styles/reset.css';
import './App.css';
import './styles/default.css';

const App = () => {
  return (
    <Provider store={store}>
      <div className='App'>
        <Router>
          <Routes>
            <Route path='/' element={<Index />} />
            <Route path='/wedding/:id' element={<DynamicMain />} />
            <Route path='/invitation/:id' element={<DynamicMain />} />
            <Route path='/portfolio/:id' element={<DynamicPortfolioMain />} />
            <Route path='/designer' element={<Designer />} />
            <Route path='*' element={<Navigate to='/' />} />
            <Route path='/hea-invitations-list' element={<PageList />} />
          </Routes>
        </Router>
      </div>
    </Provider>
  );
};

export default App;
